import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { SwiperOptions } from '@/utils/swiperUtils';

import { ImageWidths, ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import { CarouselCoverFlowViewModel } from './CarouselCoverFlowModule.types';
import { getComponentProps, getDefaultSwiperOptions } from '@/utils/vueUtils';

import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import Arrow from '@/assets/icons/arrow-long.svg?inline';

import CarouselPagination from '@/components/CarouselPagination/CarouselPagination.vue';
import CarouselArrow from '@/components/CarouselArrow/CarouselArrow.vue';
import SwiperMixin from '@/mixins/SwiperMixin';
import { SegmentElement } from '@/plugins/utm/SegmentElement';

@Component({
  components: {
    Arrow,
    ResponsiveImage,
    ResponsiveImageRatio,
    CarouselPagination,
    CarouselArrow,
  },
  props: getComponentProps<CarouselCoverFlowViewModel>({
    // BackgroundImage: { Url: '', Alt: '' },
    Slides: [],
    IsVertical: false,
  }),
})
export default class CarouselCoverFlowModule extends mixins(SwiperMixin) {
  p!: CarouselCoverFlowViewModel;

  ratioPortrait: string = '2x3';
  ratioLandscape: string = '3x2';

  imageSizes: ImageSizes = {
    def: new ImageSize([560, 812]),
    sizes: {
      sm: new ImageSize([768, 1024]),
      md: new ImageSize([992, 744]),
      lg: new ImageSize([1200, 900]),
      xl: new ImageSize([1440, 1080]),
    },
  };

  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  mapSizes: ImageSizes = {
    def: new ImageSize([560, 812]),
    sizes: {
      sm: new ImageSize([768, 1024]),
      md: new ImageSize([992, 744]),
      lg: new ImageSize([1200, 900]),
      xl: new ImageSize([1440, 1080]),
    },
  };

  get swiperOption(): SwiperOptions {
    return {
      ...getDefaultSwiperOptions(this.uuid),
      spaceBetween: 0,
      speed: 250,
      slidesPerView: 3,
      touchRatio: 0,
      freeMode: false,
      freeModeSticky: true,
      virtualTranslate: true,
      width: 617,
      height: 457,
      centeredSlides: true,
      breakpoints: undefined,
    };
  }

  onModuleInteraction() {
    SegmentElement.sendEvent('moduleInteraction', {
      module_type_id: this.$attrs['data-segmentid'],
      module_type_name: this.$attrs.type,
      interaction_type: 'carousel',
      position: this.activeIndex + 1,
    })
  }

  get ratio() {
    return this.p.IsVertical ? this.ratioPortrait : this.ratioLandscape;
  }

  activeIndex: number = 0;

  get current() {
    return this.p.Slides ? this.p.Slides[this.activeIndex] : null;
  }

  mounted() {
    this.swiper.on('transitionStart', () => {
      this.activeIndex = this.swiper.activeIndex;
    });
    this.coverWidth();
    window.addEventListener('resize', this.coverWidth);
  }

  coverWidth() {
    const covers: any = document.getElementsByClassName(
      'carousel-cover-flow__item',
    ) as HTMLCollectionOf<HTMLElement>;
    const swiperWidth: number = this.swiper.width;

    for (let i = 0; i < covers.length; i++) {
      let element = covers[i];
      element.style.width = '' + swiperWidth + 'px';
    }
  }
}
